module.exports = __webpack_public_path__ + "de77a722/img/share-icon.0f8a11b4.svg";